/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const tractor_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.497 12.495a8.467 8.467 0 0 0-6.033-3.69 8.437 8.437 0 0 0-4.23.606M.75 11.025A8.407 8.407 0 0 1 3.235 9.41M19.5 18.87h.742M4.997 2.994h-1c0-.538-.216-2.243.639-2.243h7.222c.855 0 .639 1.705.639 2.243h-1m-6.5 0h6.5m-6.5 0L3.235 9.41m8.262-6.418 1.477 5.757 7.683 1.19c.628.178 1.09.79 1.09 1.443v4.685m0 0a3.375 3.375 0 1 1-5.23 3.182m5.23-3.182a3.359 3.359 0 0 0-1.875-.568c-1.986 0-3.572 1.786-3.355 3.75m-5.276.003a5.25 5.25 0 1 1-9.485-4.507 5.25 5.25 0 0 1 9.485 4.507Zm0 0 5.276-.003M4.247 17a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 0 0-4.5 0Zm15.625 2.253a.386.386 0 0 0 .375-.375.386.386 0 0 0-.375-.375.386.386 0 0 0-.375.375c0 .199.176.375.375.375Z"
    />
  </svg>
)
export default tractor_medium
